import { useMemo, useState, type ReactNode } from 'react';
import { initialLang, saveLang, SURVEY_STRINGS, SurveyI18nContext, type Lang } from '../i18n';

/** Holds the page's language; the choice is remembered for the viewer's next visit. */
export function SurveyI18nProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>(initialLang);
  const value = useMemo(
    () => ({
      lang,
      t: SURVEY_STRINGS[lang],
      setLang: (next: Lang) => {
        setLang(next);
        saveLang(next);
      },
    }),
    [lang],
  );
  return <SurveyI18nContext.Provider value={value}>{children}</SurveyI18nContext.Provider>;
}
